import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listOldData() {
        return axios.get('olddata')
    },

    updateOldData(oldDataId, oldDataObj) {
        return axios.post(`olddata/update/${oldDataId}`, oldDataObj)
    },

    addOldData(oldDataObj) {
        return axios.post('olddata', oldDataObj)
    },

    deleteOldData(oldDataId) {
        return axios.post(`olddata/delete/${oldDataId}`)
    }
}